export const baseUrl = 'https://api.themoviedb.org/3'
export const API_KEY = "235a4f1dfdfeeb3c56aca676e7d36903"
export const imageUrl = 'https://image.tmdb.org/t/p/original'